import { State, Validation } from './types';

const expression =
  // eslint-disable-next-line
  /^(:?https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/?.*)?|^((:?https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])?(\/?.*)$/;
const urlRe = new RegExp(expression, 'i');

const isValidIpCidr = (input: string): boolean => {
  const [addr, prefix] = input.split('/');
  const ipv4Regex =
    /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
  if (ipv4Regex.test(addr)) {
    if (prefix === undefined) return true;
    const p = Number(prefix);
    return p >= 0 && p <= 32;
  }
  const ipv6Regex =
    /^(([0-9A-Fa-f]{1,4})(:[0-9A-Fa-f]{1,4}){7}|(([0-9A-Fa-f]{1,4}:){1,7}:)|(::[0-9A-Fa-f]{1,4}){1,7})$/;
  if (ipv6Regex.test(addr)) {
    if (prefix === undefined) return true;
    const p = Number(prefix);
    return p >= 0 && p <= 128;
  }
  return false;
};

export const onValidateTargetSystem = (state: State) => {
  const {
    name,
    location,
    selectedAuthType,
    format,
    organization,
    grantType,
    allowIP,
  } = state;
  state.validation = {
    ...state.validation,
    name: name.length > 0,
    organization: organization.length > 0,
    grantType: grantType.length > 0,
    location:
      location.length > 10 &&
      location.indexOf('.') !== -1 &&
      urlRe.test(location),
    selectedAuthType: !!selectedAuthType,
    format: !!format,
    allowIP: allowIP && allowIP.length > 0 ? isValidIpCidr(allowIP) : true,
  };

  const valid = state.validation;
  state.valid =
    state.valid &&
    valid.name &&
    valid.location &&
    valid.format &&
    valid.selectedAuthType;
};

export const onValidateApiKey = (state: State) => {
  const { key, updateKey } = state;

  state.validation = {
    ...state.validation,
    key: updateKey === false || key.length >= 32,
  };

  const valid = state.validation;
  state.valid = valid.key;

  onValidateTargetSystem(state);
};

export const onValidateOauth = (state: State) => {
  const { username, password, authEndpoint, updateKey, redirectURI, code } =
    state;

  state.validation = {
    ...state.validation,
    username: username.length > 0,
    password:
      (password.length > 0 && updateKey === true) || updateKey === false,
    authEndpoint: authEndpoint.length > 10 && urlRe.test(authEndpoint),
    code:
      state.grantType !== 'authorization_code' ||
      (code ? code.length > 0 : false),
    redirectURI:
      state.grantType !== 'authorization_code' ||
      (redirectURI ? urlRe.test(redirectURI) : true),
  };

  const valid = state.validation;
  state.valid =
    valid.username &&
    valid.password &&
    valid.authEndpoint &&
    valid.code &&
    valid.redirectURI;

  onValidateTargetSystem(state);
};

export const onValidateBasicOrDigest = (state: State) => {
  const { username, password, updateKey } = state;

  state.validation = {
    ...state.validation,
    username: username.length > 0,
    password: password.length > 0,
  };

  const valid = state.validation;
  if (updateKey) {
    state.valid = valid.username && valid.password;
  } else {
    state.valid = valid.username;
  }

  onValidateTargetSystem(state);
};

export const onValidateTLS = (state: State) => {
  state.valid = !!state.legacy;

  onValidateTargetSystem(state);
};

export const onValidateHMACSHA256 = (state: State) => {
  state.valid = true;
  onValidateTargetSystem(state);
};

type ValidationKey = keyof Validation;
export const isInvalid = (key: ValidationKey, state: State) => {
  return state.messages && !state.validation[key];
};
